export {
    getShown,
    getTerm,
    getQueryTime,
    getSearchResults,
    getIsSearching,
    hasSearchResultError,
    getSearchStartTime,
    getIsSearchingKb,
    getIsSearchingPortals,
    getIsSearchingRequestTypes,
} from './search';
